var _path, _rect, _rect2, _path2, _path3, _path4, _rect3, _rect4, _path5, _rect5, _rect6, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKubeproxyinline = function SvgKubeproxyinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1D7E0",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M19.916 73.528a2 2 0 0 1-1.832 0L11.5 70.136l-6.416-3.305A2 2 0 0 1 4 65.053V48.947a2 2 0 0 1 1.084-1.778l13-6.697a2 2 0 0 1 1.832 0l13 6.697A2 2 0 0 1 34 48.947v16.106a2 2 0 0 1-1.084 1.778l-13 6.697Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 7,
    x: 13,
    y: 48,
    fill: "#D6EBFF",
    stroke: "#0073E6",
    strokeWidth: 2,
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 7,
    x: 13,
    y: 59,
    stroke: "#A7B1BE",
    strokeWidth: 2,
    rx: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1D7E0",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M40.916 40.528a2 2 0 0 1-1.832 0L32.5 37.136l-6.416-3.305A2 2 0 0 1 25 32.053V15.947a2 2 0 0 1 1.084-1.778l13-6.697a2 2 0 0 1 1.832 0l13 6.697A2 2 0 0 1 55 15.947v16.106a2 2 0 0 1-1.084 1.778l-13 6.697Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1D7E0",
    strokeWidth: 2,
    d: "M19 41V25a1 1 0 0 1 1-1h5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1D7E0",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M61.916 73.528a2 2 0 0 1-1.832 0L53.5 70.136l-6.416-3.305A2 2 0 0 1 46 65.053V48.947a2 2 0 0 1 1.084-1.778l13-6.697a2 2 0 0 1 1.832 0l13 6.697A2 2 0 0 1 76 48.947v16.106a2 2 0 0 1-1.084 1.778l-13 6.697Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 7,
    x: 55,
    y: 48,
    fill: "#D6FFFC",
    stroke: "#00877C",
    strokeWidth: 2,
    rx: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 7,
    x: 55,
    y: 59,
    stroke: "#A7B1BE",
    strokeWidth: 2,
    rx: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1D7E0",
    strokeWidth: 2,
    d: "M61 41V25a1 1 0 0 0-1-1h-5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 7,
    x: 34,
    y: 15,
    fill: "#FFF5D6",
    stroke: "#FFBF00",
    strokeWidth: 2,
    rx: 1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 7,
    x: 34,
    y: 26,
    fill: "#FBDADA",
    stroke: "#EB4748",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EB4748",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m34 26 12 7"
  })));
};
export default SvgKubeproxyinline;